import { RecommendTargetData, ExtractRequestFn, InterestSearchResult } from '@tt4b/ttam-enums';
import { useInterstKeywordsInfoApi } from '@tt4b/ttam-hooks';
import { Ref, ref } from '@vue/composition-api';

export const recommendBehaviorTargetData: Ref<RecommendTargetData> = ref(null);
export const recommendInterestKeywordsList: Ref<ExtractRequestFn<typeof useInterstKeywordsInfoApi>> = ref([]);
export const originRecommendInterestKeywordsList: Ref<InterestSearchResult[]> = ref([]);
